export default __webpack_public_path__ + "static/media/JSON.9e35b098.png";